import { StatModule } from "@/core/modules/stat/objects/StatModule";

import DpiDeliveredView from "./views/DpiDeliveredView.vue";

export const dpiDelivered: StatModule = new StatModule("dpi", "DpiDelivered", "dpiStat", DpiDeliveredView);
